import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

export function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.history.scrollRestoration = 'manual';
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [pathname]);
}